export const ICONS_ENUM = {
  CORE: 'core',
  EVENTS: 'events',
  OWN_ACCOUNT: 'ownaccount',
  PRIMARY_MARKET: 'primarymarket',
  TRANSACTIONS: 'transactions',
  REPORTING: 'reporting',
  MENU: 'menu',
  MENU_OPEN: 'menuopen',
  FAVORITE: 'favorite',
  TEMPLATE: 'template',
  PIN: 'pin',
  USER: 'user',
  HELP: 'help',
  SETTINGS: 'settings',
  CALENDAR: 'calendar',
  BELL: 'bell',
  REFRESH: 'refresh',
  MESSAGES: 'messages',
  AUDIT: 'audit',
  EXPORT: 'export',
  UPLOAD: 'upload',
  DUPLICATE: 'duplicate',
  EDIT: 'edit',
  TRASH: 'trash',
  CLOCK: 'clock',
  DOCUMENT: 'document',
  CLIP: 'clip',
  LINK: 'link',
  PLACE: 'place',
  LOCK: 'lock',
  EMAIL: 'email',
  NOTES_NO: 'notesno',
  NOTES_NO_EDIT: 'notesnoedit',
  NOTES_YES: 'notesyes',
  NOTES_YES_EDIT: 'notesyesedit',
  TAKE_ACTION_DOWN: 'takeactiondown',
  TAKE_ACTION_UP: 'takeactionup',
  TAKE_ACTION_LEFT: 'takeactionleft',
  TAKE_ACTION_RIGHT: 'takeactionright',
  TAKE_ACTION_DOWN_OTHERS: 'takeactiondownothers',
  EXIT: 'exit',
  GOTO: 'goto',
  ARROW_LEFT2: 'arrowleft2',
  ARROW_RIGHT2: 'arrowright2',
  ARROW_UP2: 'arrowup2',
  ARROW_DOWN2: 'arrowdown2',
  ARROW_LEFT: 'arrowleft',
  ARROW_RIGHT: 'arrowright',
  ARROW_UP: 'arrowup',
  ARROW_DOWN: 'arrowdown',
  SEE: 'see',
  SEE_NOT: 'seenot',
  EXTENSIONS: 'extensions',
  LOADING: 'loading',
  SAVE_YES: 'saveyes',
  SAVE_NO: 'saveno',
  ALERT_UNSAVED: 'alertunsaved',
  FILTER: 'filter',
  GRID_COLUMNS: 'gridcolumns',
  PLUS: 'plus',
  MINUS: 'minus',
  CROSS: 'cross',
  SEARCH: 'search',
  SUCCESS: 'success',
  OPTIONS: 'options',
  DOT: 'dot',
  INFO: 'info',
  PROCESS: 'process',
  ALERT_CIRCLE: 'alertcircle',
  SUCCESS_CIRCLE: 'successcircle',
  INFO_CIRCLE: 'infocircle',
  ERROR_CIRCLE: 'errorcircle',
  PENDENT_CIRCLE: 'pendentcircle',
  CALCULATOR: 'calculator',
  FLAG_EN: 'flagen',
  FLAG_PT: 'flagpt',
  FLAG_ANG: 'flagang',
  CHECKBOX_REGULAR: 'checkboxregular',
  CHECKBOX_REGULAR_DARK: 'checkboxregulardark',
  CHECKBOX_DISABLE: 'checkboxdisable',
  CHECKBOX_DISABLE_DARK: 'checkboxdisabledark',
  CHECKBOX_SELECTED_DISABLE: 'checkboxselecteddisable',
  CHECKBOX_SELECTED_DISABLE_DARK: 'checkboxselecteddisabledark',
  CHECKBOX_SELECTED_DARK: 'checkboxselecteddark',
  CHECKBOX_SELECTED: 'checkboxselected',
  OP_IGUAL: 'opequal',
  OP_DIFERENTE: 'opdifferent',
  OP_CONTEM: 'opcontains',
  OP_COMECA: 'opstarts',
  OP_NAO_COMECA: 'opnotstart',
  OP_ACABA: 'opends',
  OP_NAO_ACABA: 'opnotend',
  OP_NAO_CONTEM: 'opnotcontain',
  LOGO_LIGHT: 'logolight',
  LOGO_DARK: 'logodark',
  DEVELOP: 'develop',
  TESTING: 'testing',
  ARROW_SPLITTER_LEFT: 'arrowsplitterleft',
  ARROW_SPLITTER_RIGHT: 'arrowsplitterright',
  CREATE_NEW: 'createnew',
  TRIANGLE_GRID: 'trianglegrid',
  FILTER_NOT: 'filternot',
  MENU_SMALL: 'menusmall',
  CHECKBOX_SELECTED_LIST: 'checkboxselectedlist',
  GROUP: 'group',
  GROUP_NOT: 'groupnot',
  CHECKBOX_SELECTED_NOT: 'checkboxselectednot',
  logo: 'logo',
  logoNegative: 'logoNegative',
  slogo: 'slogo',
  slogoNegative: 'slogoNegative',
};
